// AUTO-GENERATED by scripts/generate-track-art.js. Do not edit by hand.
// Keyed by Apple Music track or album id (parsed from `href`).


export const trackArt = {

};
